import React from 'react'
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import { isNil, map } from 'lodash'
import PropTypes from 'prop-types'

function Legend({ align, items, orientation }) {
  return isNil(items) ? null : (
    <List
      disablePadding
      dense
      className={`MuiList-${orientation}`}
      sx={{
        display: 'flex',
        justifyContent: align,
        '&.MuiList-horizontal': {
          flexDirection: 'column',
        },
        '&.MuiList-vertical': {
          flexDirection: 'row',
        },
      }}
    >
      {map(items, (item, key) => (
        <ListItem
          key={key}
          dense
          disablePadding
          sx={{
            mr: 4,
            padding: '0 !important',
            width: 'auto',
            '&:before': { display: 'none !important' },
          }}
        >
          <ListItemIcon
            sx={({ palette }) => ({
              mr: 1,
              minWidth: 'unset',
              color: item.iconColor
                ? palette[item.iconColor].main
                : palette.text.disabled,
            })}
          >
            {item.icon}
          </ListItemIcon>
          <ListItemText>{item.label}</ListItemText>
        </ListItem>
      ))}
    </List>
  )
}

Legend.propTypes = {
  align: PropTypes.oneOf(['flex-start', 'center', 'flex-end']),
  items: PropTypes.array,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
}
Legend.defaultProps = {
  align: 'flex-start',
  items: null,
  orientation: 'horizontal',
}

export default Legend
